import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private themeKey = 'app-theme';

  constructor() {
    this.loadTheme();
  }

  toggleTheme() {
    const body = document.body;

    body.classList.toggle('dark-theme');

    const isDark = body.classList.contains('dark-theme');
    localStorage.setItem(this.themeKey, isDark ? 'dark' : 'light');
  }

  isDarkTheme(): boolean {
    return document.body.classList.contains('dark-theme');
  }

  loadTheme() {
    const savedTheme = localStorage.getItem(this.themeKey);

    if (!savedTheme) {
      const prefersDark = window.matchMedia(
        '(prefers-color-scheme: dark)',
      ).matches;
      if (prefersDark) {
        document.body.classList.add('dark-theme');
      }
    } else if (savedTheme === 'dark') {
      document.body.classList.add('dark-theme');
    }
  }
}
